var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message sent",
    clipPath: "url(#clip0_3086_69148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.54688C5.46957 5.54688 4.96086 5.75759 4.58579 6.13266C4.21071 6.50773 4 7.01644 4 7.54688V15.5469C4 16.0773 4.21071 16.586 4.58579 16.9611C4.96086 17.3362 5.46957 17.5469 6 17.5469H8C8.55228 17.5469 9 17.9946 9 18.5469V19.7807L10.4755 18.8954C10.9491 18.6112 11.5633 18.7648 11.8475 19.2384C12.1316 19.712 11.9781 20.3262 11.5045 20.6104L8.5145 22.4044C8.20556 22.5897 7.82081 22.5946 7.5073 22.4171C7.19379 22.2396 7 21.9071 7 21.5469V19.5469H6C4.93913 19.5469 3.92172 19.1254 3.17157 18.3753C2.42143 17.6252 2 16.6077 2 15.5469V7.54688C2 6.48601 2.42143 5.46859 3.17157 4.71845C3.92172 3.9683 4.93913 3.54688 6 3.54688H18C19.0609 3.54688 20.0783 3.9683 20.8284 4.71845C21.5786 5.46859 22 6.48601 22 7.54688V13.5469C22 14.0992 21.5523 14.5469 21 14.5469C20.4477 14.5469 20 14.0992 20 13.5469V7.54688C20 7.01644 19.7893 6.50773 19.4142 6.13266C19.0391 5.75759 18.5304 5.54688 18 5.54688H6ZM8 8.54688C7.44772 8.54688 7 8.99459 7 9.54688C7 10.0992 7.44772 10.5469 8 10.5469H16C16.5523 10.5469 17 10.0992 17 9.54688C17 8.99459 16.5523 8.54688 16 8.54688H8ZM8 12.5469C7.44772 12.5469 7 12.9946 7 13.5469C7 14.0992 7.44772 14.5469 8 14.5469H14C14.5523 14.5469 15 14.0992 15 13.5469C15 12.9946 14.5523 12.5469 14 12.5469H8ZM17.7071 22.254L21.7071 18.254C22.0976 17.8635 22.0976 17.2303 21.7071 16.8398C21.3166 16.4492 20.6834 16.4492 20.2929 16.8398L17 20.1327L15.7071 18.8398C15.3166 18.4492 14.6834 18.4492 14.2929 18.8398C13.9024 19.2303 13.9024 19.8635 14.2929 20.254L16.2929 22.254C16.6834 22.6445 17.3166 22.6445 17.7071 22.254Z",
    fill: "#19BB7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3086_69148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.546875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSent);
export default __webpack_public_path__ + "static/media/message-sent.08e823fde320c91a048feb078fd9af14.svg";
export { ForwardRef as ReactComponent };